/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, Input, signal } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class LoaderComponent {
  /**
   * L'état du voile, en SIGNAL.
   *
   * C'était un booléen nu, et cela a suffi tant que toutes les pages étaient
   * en détection `Default` : n'importe quel événement finissait par réévaluer
   * le gabarit, et le voile suivait. Sous `OnPush`, plus rien ne garantit ce
   * passage — `setLoading(false)` depuis une réponse HTTP ne marque pas la
   * page sale, et le voile resterait affiché indéfiniment.
   *
   * Un signal derrière les accesseurs : toutes les signatures publiques sont
   * inchangées, et `@if (loader.getLoading())` devient réactif partout, y
   * compris dans les pages restées en `Default` — pour lesquelles cela ne
   * change rien.
   *
   * `true` par défaut, pour rester rétro-compatible avec les
   * `<app-loader></app-loader>` déjà posés sans entrée.
   */
  private readonly etat = signal<boolean>(true);

  @Input() set loading(valeur: boolean) {
    this.etat.set(valeur);
  }

  get loading(): boolean {
    return this.etat();
  }

  setLoading(loading: boolean) {
    this.etat.set(loading);
  }

  getLoading(): boolean {
    return this.etat();
  }
}
